export const SNOWPACK_PUBLIC_BRANCH = "HEAD";
export const SNOWPACK_PUBLIC_REV = "e260869";
export const SNOWPACK_PUBLIC_VERSION = "0.42.0";
export const SNOWPACK_PUBLIC_WHALESPLAINER_URL = "https://added-banxa-endpoint.whalesplainer.pages.dev";
export const SNOWPACK_PUBLIC_UNICOVE_URL = "https://unicove.com";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;